export default {"src":"/_next/static/media/whatsAppIcon.07fcea8b.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};